"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/web.dom.iterable");
// function capitalizeFirstLetter(string) {
//   return string.charAt(0) + string.slice(1)
// }

var requireComponent = require.context('./getters', true, /\.js$/);
var Getters = {};
requireComponent.keys().forEach(function (fileName) {
  var a = fileName.lastIndexOf('/');
  fileName = '.' + fileName.slice(a);
  // const componetName = capitalizeFirstLetter(
  //   fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  // )

  var componetConfig = requireComponent(fileName).default;
  Getters = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, Getters), componetConfig);
});
var _default = exports.default = Getters;